import { Box, Flex, Spinner, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useDispatch, useSelector } from 'react-redux';
import { getComments } from '../../stores/slices/comments/commentsActions';
import CommentItem from './CommentItem';

const Comments = ({ commentType, commentListId }) => {
  const { comments, loading } = useSelector(state => state.comments);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getComments({
        commentType,
        commentListId,
      })
    );
  }, []);

  return (
    <React.Fragment>
      {/*  <Scrollbars autoHeight autoHeightMax={450}> */}
      <Flex overflowY="auto" flexDirection="column" flex={1} w={'full'}>
        {loading ? (
          <Box px={'4'}>
            <Spinner color="primary" />
          </Box>
        ) : comments && comments.length > 0 ? (
          comments.map((comment, i) => (
            <CommentItem comment={comment} i={i} key={comment.id} />
          ))
        ) : (
          <Text>No comments yet.</Text>
        )}
      </Flex>
      {/* </Scrollbars> */}
    </React.Fragment>
  );
};

export default Comments;
